import { ConfiguratorContextType } from "../hooks/configurator/types";

export function generatePDFData(
  modelName: string,
  code: string,
  configurator: ConfiguratorContextType
) {
  const data: any = {
    model: modelName,
    garageCode: code,
    options: [],
  };

  for (const section of configurator.getAllSections()) {
    for (const option of configurator.getSelectedOptions(section.id)) {
      data.options.push({
        category: section?.metadata?.categoryTitle,
        code: option?.id,
        description: option.label,
      });
    }
  }

  return encodeURIComponent(JSON.stringify(data));
}
